




import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import PGRowElementSelect from './PGRowElementSelect.vue';
import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { IDEProgram } from '@/libs/com/MetaPattern/Product/IDE/IDEProgram';

@Component({
  components: {
    PGRowElementSelect
  }
})
export default class PGRowActionTypeValue extends Vue {
  @Prop() private value!: string;
  @Prop() private isEditable!: boolean;

  valueChanged(newValue: string, newElement: BaseElement): void {
    this.$emit('valueChanged', newValue, newElement);
  }

  get options() {
    return IDEProgram.instance.getActionTypes();
  }
}
